export default __webpack_public_path__ + "static/media/ecom.71f529c5.jpg";